// GENERADO por `npm run env:dev` desde src/environments/environment.dev.ts. No editar: edita src/environments/environment.dev.ts.
// Development environment (cbcg-cards) — source for `npm run env:dev`
export const environment = {
  apiUrl: "https://wallet-backend-dev.up.railway.app/api/v1",
  production: false,
  firebase: {
      apiKey: "AIzaSyCK4o422d-W79WiC8giBOQF_YBpbPUswuE",
        authDomain: "cbcg-cards.firebaseapp.com",
        projectId: "cbcg-cards",
        storageBucket: "cbcg-cards.firebasestorage.app",
        messagingSenderId: "14374624570",
        appId: "1:14374624570:web:9fcd4126a37954a23f0403",
        measurementId: "G-Y9PZ23X54N"
  },
  didit: {
  }
  ,
  // App Check: clave de sitio de reCAPTCHA Enterprise (consola de Firebase → App Check).
  // Vacío = App Check desactivado en el cliente. Coloca aquí el valor cuando lo tengas.
  appCheck: {
    siteKey: '6Lf60NYtAAAAADDm-mlOM2CxYJfRVMzX_ohcbgwk',
  },
  features: {
    maintenanceMode: false,
    skipOnboarding: false
  }
};
